import React from "react";
import { Button, addToast } from "@heroui/react";
import api from "../services/api";

interface NewsletterSectionProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
}

export const NewsletterSection: React.FC<NewsletterSectionProps> = ({
  title = (
    <>
      Подпишитесь на нашу <span className="font-medium">рассылку</span>
    </>
  ),
  description = (
    <>Получайте информацию о новинках, акциях и специальных предложениях</>
  )
}) => {
  const [email, setEmail] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubscribe = async () => {
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      addToast({ title: "Ошибка", description: "Пожалуйста, введите корректный email.", color: "danger" });
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = { email: email.trim() };
      await api.post('/news/subscribe/', payload, { headers: { 'Content-Type': 'application/json' } });

      addToast({ title: "Спасибо подписка принята", color: "success" });
      setEmail("");
    } catch (err: any) {
      console.error('Subscribe error', err);
      const msg = err?.response?.data?.message || err?.message || 'Неизвестная ошибка';
      addToast({ title: "Возникла ошибка ппри оформлении подписки", description: msg, color: "danger" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-16 bg-content2">
      <div className="container mx-auto px-6">
        <div className="bg-primary/10 p-8 md:p-12 text-center">
          <h3 className="text-2xl md:text-3xl font-light mb-4">{title}</h3>
          <p className="text-foreground/80 mb-8 max-w-xl mx-auto">{description}</p>
          <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
            <input
              type="email"
              placeholder="Ваш email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-background border border-divider px-4 py-3 flex-grow focus:outline-none focus:border-primary"
            />
            <Button color="primary" className="font-medium" onPress={handleSubscribe} isLoading={isSubmitting}>
              Подписаться
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
